import { alpha, styled } from '@mui/material/styles';
import ListItem from '@mui/material/ListItem';
import { ListItemText } from '@mui/material';
import { ReactNode } from 'react';

interface Props {
  title: string;
  subtitle: string;
  children: ReactNode;
  nestedLevel?: number;
}

const Root = styled(ListItem)<any>(({ theme, itempadding, ...props }) => ({
  minminHeight: 44,
  width: '100%',
  borderRadius: '6px',
  margin: '28px 0 0 0',
  paddingRight: 16,
  paddingLeft: props.itempadding > 80 ? 80 : props.itempadding,
  paddingTop: 10,
  paddingBottom: 10,
  color: alpha(theme.palette.text.primary, 0.7),
  fontWeight: 600,
  letterSpacing: '0.025em',
}));

const NavGroup = (props: Props) => {
  const { title, subtitle, children, nestedLevel = 0 } = props;
  const itempadding = nestedLevel > 0 ? 38 + nestedLevel * 16 : 16;

  return (
    <>
      <Root
        component="li"
        itempadding={itempadding}
        className="fuse-list-subheader flex items-center pb-10 cursor-default"
        role="button"
      >
        <ListItemText
          className="fuse-list-subheader-text"
          sx={{
            margin: 0,
            '& > .MuiListItemText-primary': {
              fontSize: 12,
              color: 'secondary.light',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '.05em',
              lineHeight: '20px',
            },

            '& > .MuiListItemText-secondary': {
              fontSize: 11,
              color: 'text.disabled',
              letterSpacing: '.06px',
              fontWeight: 500,
              lineHeight: '1.5',
            },
          }}
          primary={title}
          secondary={subtitle}
        />
      </Root>
      {children}
    </>
  );
};

export default NavGroup;
